// @flow
import { createSelector } from 'reselect'

export const getOrganizationHolidays = state => state.get('orgHolidays')

export const getOrgHolidaysPending = createSelector(getOrganizationHolidays, holidays => holidays.get('pending'))

export const getOrganizationHolidayList = createSelector(getOrganizationHolidays, holidays => holidays.get('holidays'))

export const getOrganizationHolidaysId = createSelector(getOrganizationHolidays, holidays => holidays.get('orgId'))
